import React, { useMemo } from "react";
import {
  Flex,
  FootnoteText,
  Icon,
  Text,
  TooltipFootnoteTemplateContainer,
  TooltipFootnoteTemplatesContainer,
} from "./styles";
import { getTooltipFootnoteTemplates } from "./tooltip-footnote-templates";
import { useTooltipFootnoteStore } from "../../../../../../stores/use-tooltip-footnote-store";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { useTheme } from "styled-components";

const TooltipTemplate = ({ data }) => {
  const theme = useTheme();

  return (
    <Flex>
      <Text>Tooltip</Text>
      <Icon style={{ marginBottom: "8px" }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.682 1.33325 7.99998C1.33325 4.31798 4.31792 1.33331 7.99992 1.33331C11.6819 1.33331 14.6666 4.31798 14.6666 7.99998C14.6666 11.682 11.6819 14.6666 7.99992 14.6666ZM8.66659 5.33331C8.66659 5.7015 8.36811 5.99998 7.99992 5.99998C7.63173 5.99998 7.33325 5.7015 7.33325 5.33331C7.33325 4.96512 7.63173 4.66665 7.99992 4.66665C8.36811 4.66665 8.66659 4.96512 8.66659 5.33331ZM7.99992 6.66665C8.36811 6.66665 8.66659 6.96512 8.66659 7.33331V10.6666C8.66659 11.0348 8.36811 11.3333 7.99992 11.3333C7.63173 11.3333 7.33325 11.0348 7.33325 10.6666V7.33331C7.33325 6.96512 7.63173 6.66665 7.99992 6.66665Z"
            fill={data.color[theme.name]}
          />
        </svg>
      </Icon>
    </Flex>
  );
};

const FootnoteTemplate = ({ data }) => {
  const theme = useTheme();

  return (
    <Flex>
      <Text>Footnote</Text>
      <FootnoteText
        clr={data.color[theme.name]}
        style={{ marginBottom: "8px" }}
      >
        1
      </FootnoteText>
    </Flex>
  );
};

function TooltipFootnoteTemplates() {
  const { data, setData } = useTooltipFootnoteStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const TEMPLATES = useMemo(
    () => getTooltipFootnoteTemplates(styleguideSetup),
    [styleguideSetup]
  );

  return (
    <TooltipFootnoteTemplatesContainer>
      {TEMPLATES.map((template) => (
        <TooltipFootnoteTemplateContainer
          key={template.id}
          isSelected={template.id === data.id}
          onClick={() => {
            setData({ ...template });
            setDrawers({ templates: false, settings: true });
          }}
        >
          {template.macroType === "tooltip" && (
            <TooltipTemplate data={template} />
          )}
          {template.macroType === "footnote" && (
            <FootnoteTemplate data={template} />
          )}
        </TooltipFootnoteTemplateContainer>
      ))}
    </TooltipFootnoteTemplatesContainer>
  );
}

export default TooltipFootnoteTemplates;
